import { useCreateOpportunityNoteMutation } from "@qw/graphql";
import { z } from "zod";
import { useToast } from "../../providers";
import { Form, type FormSubmitHandler } from "../form";
import { NoteInputField } from "./note-input-field";

export const NoteFormSchema = z.object({
  text: z.string().min(1),
});

export const NoteForm = ({ opportunityId, loading }: { opportunityId: string; loading?: boolean }) => {
  const { toast } = useToast();
  const [createNote] = useCreateOpportunityNoteMutation();

  const defaultValues = { text: "" };

  const handleSubmit: FormSubmitHandler<z.infer<typeof NoteFormSchema>> = async (values, methods) =>
    await createNote({
      variables: { input: { opportunityId, ...values } },
      onCompleted: () => methods.reset(),
      onError: () => toast({ title: "Error", description: "An error occurred.", variant: "destructive" }),
      refetchQueries: ["OpportunityNotes"],
    });

  return (
    <Form validationSchema={NoteFormSchema} defaultValues={defaultValues} onSubmit={handleSubmit}>
      <NoteInputField name="text" placeholder="Add a note" loading={loading} />
    </Form>
  );
};
